<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right">
        <el-button size="mini" type="primary" plain @click="onExport" v-if="!isMB">导出</el-button>
        <!-- <el-button size="mini" type="primary" @click="create" icon="el-icon-plus">添加</el-button> -->
        <!-- <el-button size="mini" type="danger" @click="delRows">删除</el-button> -->
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <!-- <el-table-column label="操作" fixed="right" align="center" width="48">
          <template slot-scope="{row}">
            <el-button type="text" @click="edit(row)">处理</el-button>
          </template>
        </el-table-column> -->
        <el-table-column prop="HandleStatus" label="状态" width="75" align="center" fixed="right">
          <template slot-scope="{row}">
            <el-link class="warningLink" :underline="false" v-if="row.HandleStatus==0" @click="edit(row)">待处理</el-link>
            <el-link class="successLink" :underline="false" v-else-if="row.HandleStatus==1" @click="edit(row)">已处理</el-link>
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload" @to-leave="toLeave" />
    <leave-dialog ref="leaveDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/st/attendance/list";
import editDialog from "@/components/st/attendance/editDialog";
import leaveDialog from "@/components/st/leave/editDialog";

export default {
  name: "attendance",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    leaveDialog,
  },
  data() {
    return {
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    onExport() {
      this.$refs.list.onExport();
    },
    toLeave(data) {
      this.$refs.leaveDialog.openCreate(data);
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.AttendanceId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped>
.warningLink {
  color: #e6a23c !important;
  text-decoration: underline;
}
/* .warningLink.is-underline:hover::after {
  border-color: #e6a23c !important;
} */
.warningLink:hover {
  color: #f7b34d !important;
}
.successLink {
  color: #67c23a !important;
  text-decoration: underline;
}
.successLink:hover {
  color: #78d34b !important;
}
/* .successLink.is-underline:hover::after {
  border-color: #67c23a !important;
} */
</style>